export const isDevelopment = () => process.env.NODE_ENV === 'development';

export const isServer = () => typeof window === 'undefined';

type NonEmptyFields<T> = {
  [P in keyof T]: NonNullable<T[P]>;
};

export const removeEmptyFields = <T extends object>(
  obj: T,
): NonEmptyFields<T> => {
  return Object.fromEntries(
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    Object.entries(obj).filter(([_, value]) => {
      // null, undefined 체크
      if (value == null) return false;

      // 빈 문자열 체크
      if (typeof value === 'string' && value.trim() === '') return false;

      // 빈 배열 체크
      if (Array.isArray(value) && value.length === 0) return false;

      // 빈 객체 체크
      if (
        typeof value === 'object' &&
        !Array.isArray(value) &&
        value !== null &&
        Object.keys(value).length === 0
      )
        return false;

      // 0은 유효한 값으로 처리
      if (typeof value === 'number') return true;

      return true;
    }),
  ) as NonEmptyFields<T>;
};

// 24-02-20\n14:30:00
export const formatDate = (
  isoString: string,
  onlyDate: boolean = false,
  fullYear: boolean = false,
) => {
  const date = new Date(isoString);

  const year = fullYear
    ? date.getFullYear().toString()
    : date.getFullYear().toString().slice(-2);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  if (!onlyDate) {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day}\n${hours}:${minutes}:${seconds}`;
  }

  return `${year}-${month}-${day}`;
};

/**
 * 'YYYY-MM-DD' 형식의 날짜 문자열을 'YY-MM-DD' 형식으로 변환합니다.
 * @param dateString 'YYYY-MM-DD' 형식의 날짜 문자열 (예: '2014-01-01')
 * @returns 'YY-MM-DD' 형식의 날짜 문자열 (예: '14-01-01')
 */
export const formatDateString = (dateString: string): string => {
  // 입력값이 유효한지 확인
  if (!dateString || dateString.length !== 10) {
    return dateString; // 유효하지 않은 입력은 그대로 반환
  }

  // YYYY-MM-DD 형식에서 YY-MM-DD 형식으로 변환
  return dateString.substring(2); // 앞의 2자리를 제거
};

export const scrollToTop = () => {
  if (typeof window !== 'undefined') {
    window.scrollTo({
      top: 0,
      behavior: 'instant',
    });
  }
};
